class HeroModuleMedia extends HTMLElement {
  constructor() {
    super();
    // define refs
    this.video = null;
    this.playPauseBtn = null;
    this.muteUnmuteBtn = null;
    
    // Icon SVGs
    this.playIcon = `<svg width="21" height="26" viewBox="0 0 21 26" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 1L19.6667 13L1 25V1Z" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>`;
    this.pauseIcon = `<svg width="21" height="26" viewBox="0 0 21 26" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="2" y="2" width="6" height="22" stroke="white" stroke-width="2" rx="2"/><rect x="13" y="2" width="6" height="22" stroke="white" stroke-width="2" rx="2"/></svg>`;
    this.muteIcon = `<svg width="26" height="21" viewBox="0 0 26 21" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M24.7412 6.93764L17.6188 14.06M17.6188 6.93764L24.7412 14.06M11.6835 1.83567C11.6833 1.67032 11.6341 1.50876 11.5421 1.37136C11.4501 1.23396 11.3195 1.12688 11.1667 1.06364C11.014 1.00039 10.8459 0.983824 10.6837 1.01601C10.5215 1.04821 10.3725 1.12772 10.2555 1.24451L6.23849 5.26033C6.08346 5.41628 5.89903 5.53992 5.69587 5.62407C5.49272 5.70823 5.27488 5.75123 5.05499 5.75058H2.18706C1.87223 5.75058 1.5703 5.87565 1.34768 6.09826C1.12506 6.32088 1 6.62281 1 6.93764V14.06C1 14.3748 1.12506 14.6767 1.34768 14.8994C1.5703 15.122 1.87223 15.247 2.18706 15.247H5.05499C5.27488 15.2464 5.49272 15.2894 5.69587 15.3736C5.89903 15.4577 6.08346 15.5813 6.23849 15.7373L10.2543 19.7543C10.3713 19.8716 10.5206 19.9515 10.6831 19.9839C10.8455 20.0162 11.014 19.9997 11.1671 19.9362C11.3201 19.8728 11.4509 19.7653 11.5429 19.6275C11.6348 19.4897 11.6838 19.3276 11.6835 19.162V1.83567Z" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>`;
    this.unmuteIcon = `<svg width="26" height="21" viewBox="0 0 26 21" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M11.6835 1.83567C11.6833 1.67032 11.6341 1.50876 11.5421 1.37136C11.4501 1.23396 11.3195 1.12688 11.1667 1.06364C11.014 1.00039 10.8459 0.983824 10.6837 1.01601C10.5215 1.04821 10.3725 1.12772 10.2555 1.24451L6.23849 5.26033C6.08346 5.41628 5.89903 5.53992 5.69587 5.62407C5.49272 5.70823 5.27488 5.75123 5.05499 5.75058H2.18706C1.87223 5.75058 1.5703 5.87565 1.34768 6.09826C1.12506 6.32088 1 6.62281 1 6.93764V14.06C1 14.3748 1.12506 14.6767 1.34768 14.8994C1.5703 15.122 1.87223 15.247 2.18706 15.247H5.05499C5.27488 15.2464 5.49272 15.2894 5.69587 15.3736C5.89903 15.4577 6.08346 15.5813 6.23849 15.7373L10.2543 19.7543C10.3713 19.8716 10.5206 19.9515 10.6831 19.9839C10.8455 20.0162 11.014 19.9997 11.1671 19.9362C11.3201 19.8728 11.4509 19.7653 11.5429 19.6275C11.6348 19.4897 11.6838 19.3276 11.6835 19.162V1.83567Z" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M15.5 8.5C16.1667 9.16667 16.6667 10.1667 16.6667 11.3333C16.6667 12.5 16.1667 13.5 15.5 14.1667" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M19.1667 5.66667C20.5 7 21.3333 9 21.3333 11.3333C21.3333 13.6667 20.5 15.6667 19.1667 17" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>`;
    
    // bind methods
    this.updatePlayPauseIcon = this.updatePlayPauseIcon.bind(this);
    this.updateMuteUnmuteIcon = this.updateMuteUnmuteIcon.bind(this);
    this.handlePlayPauseClick = this.handlePlayPauseClick.bind(this);
    this.handleMuteUnmuteClick = this.handleMuteUnmuteClick.bind(this);
  }

  connectedCallback() {
    // find elements within this component
    this.video = this.querySelector('video');
    this.playPauseBtn = this.querySelector('.hero__module_media-play-pause-button');
    this.muteUnmuteBtn = this.querySelector('.hero__module_media-mute-unmute-button');

    if (!this.video || !this.playPauseBtn || !this.muteUnmuteBtn) return;

    // set up event listeners
    this.playPauseBtn.addEventListener('click', this.handlePlayPauseClick);
    this.muteUnmuteBtn.addEventListener('click', this.handleMuteUnmuteClick);
    
    // update icons when video state changes
    this.video.addEventListener('play', this.updatePlayPauseIcon);
    this.video.addEventListener('pause', this.updatePlayPauseIcon);
    this.video.addEventListener('volumechange', this.updateMuteUnmuteIcon);

    // initialize icons based on initial video state
    this.updatePlayPauseIcon();
    this.updateMuteUnmuteIcon();
  }

  updatePlayPauseIcon() {
    if (!this.video || !this.playPauseBtn) return;
    
    if (this.video.paused) {
      this.playPauseBtn.innerHTML = this.playIcon;
      this.playPauseBtn.setAttribute('aria-label', 'Play');
    } else {
      this.playPauseBtn.innerHTML = this.pauseIcon;
      this.playPauseBtn.setAttribute('aria-label', 'Pause');
    }
  }

  updateMuteUnmuteIcon() {
    if (!this.video || !this.muteUnmuteBtn) return;
    
    if (this.video.muted) {
      this.muteUnmuteBtn.innerHTML = this.muteIcon;
      this.muteUnmuteBtn.setAttribute('aria-label', 'Unmute');
    } else {
      this.muteUnmuteBtn.innerHTML = this.unmuteIcon;
      this.muteUnmuteBtn.setAttribute('aria-label', 'Mute');
    }
  }

  handlePlayPauseClick() {
    if (!this.video) return;
    
    if (this.video.paused) {
      this.video.play().then(() => {
        // Icon will be updated by the 'play' event listener
      }).catch((error) => {
        console.error('Error playing video:', error);
        // Icon stays as play since video didn't start
      });
    } else {
      this.video.pause();
      // Icon will be updated by the 'pause' event listener
    }
  }

  handleMuteUnmuteClick() {
    if (!this.video) return;
    
    this.video.muted = !this.video.muted;
    // Icon will be updated by the 'volumechange' event listener
  }
}

customElements.define('hero-module-media', HeroModuleMedia);
